import { FileState } from '../types';

export const VALID_TYPE_STATES = ['added', 'exists'] as FileState['state'][];
